import React, { FC, HTMLAttributes } from 'react';
import classNames from '../../helpers/classNames';
import styles from './Text.module.scss';

interface TextProps extends HTMLAttributes<HTMLSpanElement> {
  clamp?: number;
}

const Text: FC<TextProps> = props => {
  const { clamp, className, style, ...rest } = props;

  return (
    <span
      className={classNames(className, styles.text)}
      data-clamp={!!clamp}
      style={{
        ...style,
        ...(clamp ? { '--clamp-value': clamp } : {})
      }}
      {...rest}
    />
  );
};

export default Text;
